var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPolygonServicesSideMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2358 7.11719C13.4784 7.11719 14.4858 6.10983 14.4858 4.86719C14.4858 3.62455 13.4784 2.61719 12.2358 2.61719C10.9932 2.61719 9.98584 3.62455 9.98584 4.86719C9.98584 6.10983 10.9932 7.11719 12.2358 7.11719Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.73584 13.8672C5.97848 13.8672 6.98584 12.8598 6.98584 11.6172C6.98584 10.3746 5.97848 9.36719 4.73584 9.36719C3.4932 9.36719 2.48584 10.3746 2.48584 11.6172C2.48584 12.8598 3.4932 13.8672 4.73584 13.8672Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9858 22.1172C17.2284 22.1172 18.2358 21.1098 18.2358 19.8672C18.2358 18.6246 17.2284 17.6172 15.9858 17.6172C14.7432 17.6172 13.7358 18.6246 13.7358 19.8672C13.7358 21.1098 14.7432 22.1172 15.9858 22.1172Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4858 9.36719C21.7284 9.36719 22.7358 8.35983 22.7358 7.11719C22.7358 5.87455 21.7284 4.86719 20.4858 4.86719C19.2432 4.86719 18.2358 5.87455 18.2358 7.11719C18.2358 8.35983 19.2432 9.36719 20.4858 9.36719Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3154 6.52522L14.4062 5.45911",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5634 6.37231L6.4082 10.112",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.55029 12.948L14.1709 18.5365",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7349 17.745L19.7369 9.23926",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonServicesSideMenu);
export default __webpack_public_path__ + "static/media/PolygonServicesSideMenu.dc5925cf257d9bfbd9562eb1dac28b00.svg";
export { ForwardRef as ReactComponent };